/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Backend_Development_Ops_Title3Inputs */

const en_svc_backend_development_ops_title3 = /** @type {(inputs: Svc_Backend_Development_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observability from day one`)
};

const ar_svc_backend_development_ops_title3 = /** @type {(inputs: Svc_Backend_Development_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مراقبة من اليوم الأول`)
};

const bn_svc_backend_development_ops_title3 = /** @type {(inputs: Svc_Backend_Development_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রথম দিন থেকেই অবজারভেবিলিটি`)
};

const de_svc_backend_development_ops_title3 = /** @type {(inputs: Svc_Backend_Development_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beobachtbarkeit vom ersten Tag an`)
};

const es_svc_backend_development_ops_title3 = /** @type {(inputs: Svc_Backend_Development_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observabilidad desde el primer día`)
};

const fr_svc_backend_development_ops_title3 = /** @type {(inputs: Svc_Backend_Development_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observabilité dès le premier jour`)
};

const pt_svc_backend_development_ops_title3 = /** @type {(inputs: Svc_Backend_Development_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observabilidade desde o primeiro dia`)
};

const zh_svc_backend_development_ops_title3 = /** @type {(inputs: Svc_Backend_Development_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从第一天开始的可观察性`)
};

const tr_svc_backend_development_ops_title3 = /** @type {(inputs: Svc_Backend_Development_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İlk günden itibaren gözlemlenebilirlik`)
};

const ru_svc_backend_development_ops_title3 = /** @type {(inputs: Svc_Backend_Development_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наблюдаемость с первого дня`)
};

const pl_svc_backend_development_ops_title3 = /** @type {(inputs: Svc_Backend_Development_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obserwowalność od pierwszego dnia`)
};

/**
* | output |
* | --- |
* | "Observability from day one" |
*
* @param {Svc_Backend_Development_Ops_Title3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_backend_development_ops_title3 = /** @type {((inputs?: Svc_Backend_Development_Ops_Title3Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Backend_Development_Ops_Title3Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_backend_development_ops_title3(inputs)
	if (locale === "bn") return bn_svc_backend_development_ops_title3(inputs)
	if (locale === "de") return de_svc_backend_development_ops_title3(inputs)
	if (locale === "es") return es_svc_backend_development_ops_title3(inputs)
	if (locale === "fr") return fr_svc_backend_development_ops_title3(inputs)
	if (locale === "pt") return pt_svc_backend_development_ops_title3(inputs)
	if (locale === "zh") return zh_svc_backend_development_ops_title3(inputs)
	if (locale === "tr") return tr_svc_backend_development_ops_title3(inputs)
	if (locale === "ru") return ru_svc_backend_development_ops_title3(inputs)
	if (locale === "pl") return pl_svc_backend_development_ops_title3(inputs)
	return en_svc_backend_development_ops_title3(inputs)
});
export { svc_backend_development_ops_title3 as "svc_backend-development_OPS_title" }